import React, { FC } from "react";

import { Pill } from "../../common";
import { StatusSet } from "../../../types/GlobalTypes";
import { STATUS_CONFIG, StatusConfigProps } from "../../../constants";

type Props = {
  set: StatusSet;
  status: string | number;
  noIcon?: boolean;
  handler?: (
    status: string | number,
    statusConfig: StatusConfigProps
  ) => StatusConfigProps;
  useShortText?: boolean;
  dataTest?: string;
};

export const StatusPill: FC<Props> = ({
  set,
  status,
  noIcon,
  handler,
  useShortText = false,
  dataTest,
}) => {
  const statusProps = STATUS_CONFIG[set];
  const statusConfig = handler
    ? handler(status, statusProps[status])
    : statusProps[status];

  return (
    <Pill
      {...statusConfig}
      text={
        useShortText && statusConfig.shortText
          ? statusConfig.shortText
          : statusConfig.text
      }
      icon={noIcon ? undefined : statusConfig.icon}
      dataTest={dataTest}
    />
  );
};
